
// TODO: refactor and optimize this class!
class BanksForm {
    constructor(el, opts) {
        if (!el) {
            console.error('FilterForm class constructor requires "el" argument!');
            return;
        }

        const submitHandler = _.debounce(opts.submitHandler, 700);

        let $filterForm = $(el);

        this.banksFrom = 0;
        this.banksTo = banksPerPage;
        this.$filterForm = $filterForm;

        if (!$filterForm.length) {
            console.error('FilterForm constructor can\'t find given "el" in DOM!');
            return;
        }

        let $inputs = $($filterForm.get(0).elements);

        $inputs.on("change", event => {
            event.preventDefault();
            $inputs.blur();
            $filterForm.trigger("submit");
        });

        $filterForm
            .on("submit", event => {
                event.preventDefault();
                submitHandler($filterForm);
                return false;
            })
            .trigger("submit");

        resetFilterButton.on("click", () => {
            this.resetFilterForm();
            $inputs.trigger('change');
            // submitHandler($filterForm);
        });


        this.$inputs = $inputs;
        $filterForm.trigger("submit");
    }

    resetFilterForm() {
        this.$filterForm[0].reset();
        {
            let value = sliderFirstPayment.sliderRange.options.start;
            sliderFirstPayment.sliderRange.set(value);
        }
        {
            let value = sliderPrice.sliderRange.options.start;
            sliderPrice.sliderRange.set(value);
            resetInpRender(sliderPrice);
        }
        {
            let value = sliderYears.sliderRange.options.start;
            sliderYears.sliderRange.set(value);
            resetInpRender(sliderYears);
        }

        function resetInpRender(slider) {
            let $elSlider = $(slider.sliderRange.target);
            let type  = slider.type;
            let $inp =  $elSlider.find('input');
            let inpValue = Math.round($inp.val());
            let valueToRender = inpValue.toLocaleString('ru-RU');
            let renderValue = $elSlider.find('[data-value-render]');
            window.requestAnimationFrame(() => {
                if ( type === 'price' || type === 'firstPayment') {
                    renderValue.html( valueToRender + ' ₽' );
                } else if ( type === 'years') {
                    renderValue.html(valueToRender + ' ' + declOfNum(inpValue, ['год', 'года', 'лет']) );
                }
            });
            $inp.trigger('change');
            // убираем фокус с инпута при движении ползунка на мобилке
            $inp.blur();
        }

    }

    /*save() {

    }

    restore() {

    }*/
}
